import { createAction } from '@saucelabs/sl-util-redux';
import { push } from 'connected-react-router';

import * as types from './types';

export const updateColumnsRatio = createAction(types.UPDATE_COLUMNS_RATIO);
export const videoPlayerMounted = createAction(types.VIDEO_PLAYER_MOUNTED);
export const updateCommandsFilter = createAction(types.UPDATE_COMMANDS_FILTER);
export const appendNotification = createAction(types.APPEND_NOTIFICATION);
export const setGalleryFullScreen = createAction(types.SET_GALLERY_FULL_SCREEN);
export const setOpenSauceUser = createAction(types.SET_OPEN_SAUCE_USER);
export const cleanup = createAction(types.CLEANUP);
export const updateLogsViewerState = createAction(types.UPDATE_LOGS_VIEWER_STATE);

export const updateJobPath = ({ id, path }) => (
  push(`/tests/${id}/${path}`)
);
